var _regeneratorRuntime = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/buildhome/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var bitcoin = require("./bitcoin");

var ethereum = require("./ethereum");

var oneledger = require("./oneledger");

var _require = require("./config"),
    derivedKeyType = _require.derivedKeyType;

var util = require("./util");

var _require$TierError = require("@oneledger/middle_utility").TierError,
    ErrorType = _require$TierError.ErrorType,
    ErrorUtil = _require$TierError.ErrorUtil;

var requestErrors = ErrorType.requestErrors;
/**
 * @description Verify address based on address type
 * @param address {string} address to be verified.
 * @param addressType {string} address type which is the same as key type, it should be string of either "OLT", "BTCP2PK", "BTCP2PKH", "ETH".
 * @return {Promise<boolean|error>} promise.reject returns error object, promise.resolve returns verification result.
 */

function verify(_x, _x2) {
  return _verify.apply(this, arguments);
}

function _verify() {
  _verify = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(address, addressType) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(!util.isValidString(address) || !util.isValidString(addressType))) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddressVerifyData)));

          case 2:
            _context.t0 = addressType;
            _context.next = _context.t0 === derivedKeyType.OLT ? 5 : _context.t0 === derivedKeyType.ETH ? 6 : _context.t0 === derivedKeyType.BTCP2PK ? 7 : _context.t0 === derivedKeyType.BTCP2PKH ? 8 : 9;
            break;

          case 5:
            return _context.abrupt("return", Promise.resolve(oneledger.verifyAddress(address)));

          case 6:
            return _context.abrupt("return", Promise.resolve(ethereum.verifyAddress(address)));

          case 7:
            return _context.abrupt("return", Promise.resolve(bitcoin.verifyP2PKPublicKey(address)));

          case 8:
            return _context.abrupt("return", Promise.resolve(bitcoin.verifyAddress(address)));

          case 9:
            return _context.abrupt("return", Promise.reject(ErrorUtil.errorWrap(requestErrors.InvalidAddressType)));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _verify.apply(this, arguments);
}

module.exports = {
  verify: verify
};